import React from 'react';
import classNames from 'classnames';
import { DatePicker } from 'material-ui-pickers';
import { withStyles } from './../../../../themes/default';
import { FormControl, TextField, FormHelperText, MenuItem } from './../../../../themes/input';
import moment from 'moment';

const styles = theme => ({
  label: {
    fontWeight: 600,
    color: theme.palette.grey[700]
  },
  root: {
    borderRadius: theme.spacing.unit / 2
    // backgroundColor: theme.palette.common.white,
    // '&:focus': {
    //   backgroundColor: theme.palette.common.white
    // }
  },
  input: {
    borderRadius: theme.spacing.unit / 2,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${ theme.palette.grey[300] }`,
    fontSize: theme.typography.fontSize,
    '&:focus': {
      backgroundColor: theme.palette.common.white
    }
  },
  inputWithStartAdornment: {
    //borderLeft: 'none',
    // borderTopLeftRadius: 0,
    // borderBottomLeftRadius: 0
  },
  inputWithEndAdornment: {
    //borderRight: 'none',
    // borderTopRightRadius: 0,
    // borderBottomRightRadius: 0
  },
  select: {
    borderRadius: theme.spacing.unit / 2,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${ theme.palette.grey[300] }`,
    fontSize: theme.typography.fontSize,
    '&:focus': {
      backgroundColor: theme.palette.common.white
    }
  },
  selectMenuProps: {
    boxShadow: "none"
  },
  option: {
    fontSize: theme.typography.fontSize,
    height: theme.spacing.unit * 2
  },
  underline: {
    '&:before, &:after': {
        display: 'none'
        // borderBottomLeftRadius: 4,
        // borderBottomRightRadius: 4
    }
  }
});

let InputTextField = ({ input, classes, label, placeholder, disabled, required, type, autoComplete, multiline, rowsMax, startAdornment, endAdornment, disablePadding, meta: { touched, error, warning }, ...other }) => (
  <FormControl fullWidth className={ classNames(
      !disablePadding ? 'FormField' : null,
      type === 'hidden' ? 'FormFieldHidden' : null
    ) }>
    <TextField {...input}
        InputProps={{
          inputProps: {
            'autoComplete': autoComplete
          },
          classes: {
            root: classes.root,
            input: classNames(
                    classes.input,
                    startAdornment ? classes.inputWithStartAdornment : null,
                    endAdornment ? classes.inputWithEndAdornment : null
                  ),
            underline: classes.underline
          },
          disableUnderline: false,
          startAdornment: startAdornment,
          endAdornment: endAdornment
        }}
        disabled={ disabled ? disabled : false }
        variant="filled"
        type={ type }
        label={ label }
        InputLabelProps={{
          shrink: true,
          classes: {
            root: classes.label
          }
        }}
        required={ required ? true : false }
        multiline={ multiline ? true : false }
        rowsMax={ rowsMax }
        placeholder={ placeholder }
        { ...other }/>
        <FormHelperText component="div" className="FormValidation">
    { (touched && error) || (touched && warning) && (
        touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))
    )}
    </FormHelperText>
  </FormControl>
);

let InputDateField = ({ input, classes, label, disabled, required, format, disablePast, disableFuture, autoOk, meta: { touched, error, warning }, ...other }) => (
  <FormControl fullWidth>
    <DatePicker
      disableFuture={ disableFuture ? disableFuture : false }
      disablePast={ disablePast ? disablePast : false }
      autoOk={ autoOk ? autoOk : true }
      variant="filled"
      cancelLabel="Cancelar"
      okLabel="Aceptar"
      label={ label }
      initialFocusedDate={ new Date() }
      value={ input.value ? input.value : new Date() }
      format={ format ? format : "DD-MM-YYYY" }
      required={ required ? true : false }
      onChange={ event => { input.onChange(moment(event).format("YYYY-MM-DD")); } }
      InputProps={{
        classes: {
          root: classes.root,
          input: classes.input,
          underline: classes.underline
        }
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          root: classes.label
        }
      }}
    />
    <FormHelperText component="div" className="FormValidation">
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </FormHelperText>
  </FormControl>
)

let SelectField = ({ input, classes, label, disabled, required, meta: { touched, error }, children, ...custom }) => (
  <FormControl fullWidth className="FormField" disabled={ disabled ? disabled : false }>
    <TextField {...input}
      variant="filled"
      select
      label={ label }
      InputProps={{
        classes: {
          root: classes.root,
          input: classes.select,
          underline: classes.underline
        },
        disableUnderline: false,
      }}
      InputLabelProps={{
        shrink: true,
        required: required ? true : false,
        classes: {
          root: classes.label
        }
      }}
      menuprops={{
        classes: {
          root: classes.selectMenuProps
        }
      }}>
      { children }
    </TextField>
    { (touched && error)  && (
      <FormHelperText component="div" className="FormValidation">
        {touched && ((error && <span>{error}</span>))}
      </FormHelperText>
    )}
  </FormControl>
);

let OptionField = ({ children, classes, ...other }) => (
  <MenuItem
    classes={{
      root: classes.option
    }}
    { ...other }
  >
    { children }
  </MenuItem>
);

InputTextField = withStyles(styles)(InputTextField);
InputDateField = withStyles(styles)(InputDateField);
SelectField    = withStyles(styles)(SelectField);
OptionField    = withStyles(styles)(OptionField);

export { InputTextField, SelectField, InputDateField, OptionField };
